module.exports = __webpack_public_path__ + "static/media/keras.15032fc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backends/keras.svg
// module id = 319
// module chunks = 0